import { Spinner } from "flowbite-react";
import { useState, useEffect } from "react";

export default function LoadingOverlay({
  enabled = true,
  message = "Loading",
}) {
  const [messageSuffix, setMessageSuffix] = useState("");
  useEffect(() => {
    const interval = setInterval(() => {
      setMessageSuffix((prev) => (prev.length < 3 ? prev + "." : ""));
    }, 500);
    return () => clearInterval(interval);
  }, []);
  return (
    <>
      {enabled && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="text-center">
            <div
              className="spinner-border inline-block h-12 w-12 animate-spin rounded-full border-4 text-blue-600"
              role="status"
            >
              <Spinner />
              {/* <span className="visually-hidden">Loading...</span> */}
            </div>
            <div className="mt-4 text-lg text-white">
              {message}
              {messageSuffix}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
